import { Button } from "primereact/button"
import { useNavigate } from "react-router-dom"

const DashboardButton = ()=>{
    const navigate = useNavigate()

    const handlePage = (e)=>{
        e.preventDefault()
        navigate('/dashboard/home')
    }
    return (
        <Button onClick={handlePage}>Vai alla Dashboard</Button>
    )
}

export default DashboardButton